import { generatePath, matchPath } from "react-router-dom";

import { AbsoluteRoute } from "../../core/routes/absoluteRoutes";
import { type MonetizationTab } from "../models";

interface MonetizationScope {
    orgId?: string | null;
    lensFolderId?: string | null;
}

export const buildMonetizationTabPath = ({
    orgId,
    lensFolderId,
    tab,
}: MonetizationScope & { tab: MonetizationTab }): string => {
    if (orgId && lensFolderId) {
        return generatePath(AbsoluteRoute.ORG_LENS_FOLDER_MONETIZATION_TAB, {
            orgId,
            lensFolderId,
            monetizationTab: tab,
        });
    }
    if (orgId) {
        return generatePath(AbsoluteRoute.ORG_MONETIZATION_TAB, { orgId, monetizationTab: tab });
    }
    return generatePath(AbsoluteRoute.MONETIZATION_TAB, { monetizationTab: tab });
};

const MONETIZATION_INDEX_ROUTES = [
    AbsoluteRoute.ORG_LENS_FOLDER_MONETIZATION,
    AbsoluteRoute.ORG_MONETIZATION,
    AbsoluteRoute.MONETIZATION,
];

// usePageRedirect returns a bare index path; re-append the tab so it is not reset.
export const resolveMonetizationRedirect = (redirect: string, tab: MonetizationTab): string =>
    MONETIZATION_INDEX_ROUTES.some((route) => matchPath(route, redirect)) ? `${redirect}/${tab}` : redirect;
